import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

import { Button } from '../../shared/ui/button';
import { Modal } from '../../shared/ui/modal';
import type { ICredentialStep, TCredentialApp } from '../../entities/credential';
import { AppIcon } from './app-icon';

interface ICredentialStepsDialogProps {
  title: string;
  description: ReactNode;
  steps: readonly ICredentialStep[];
  app: TCredentialApp | null;
  onOpenChange: (open: boolean) => void;
}

/** "Where it is used" and "can't be deleted" list the same thing: each step, and a way to it. */
export const CredentialStepsDialog = ({
  title,
  description,
  steps,
  app,
  onOpenChange,
}: ICredentialStepsDialogProps) => (
  <Modal
    open
    onOpenChange={onOpenChange}
    width="md"
    title={title}
    description={description}
    footer={
      <Button variant="secondary" size="sm" onClick={() => onOpenChange(false)}>
        Close
      </Button>
    }
  >
    {steps.length === 0 ? (
      <p className="text-data text-muted">No step uses these credentials.</p>
    ) : (
      <ul className="border-t border-border-raised">
        {steps.map((step) => (
          <li
            key={`${step.flowId}:${step.nodeKey}`}
            className="flex items-center gap-inset border-b border-border-raised py-3"
          >
            <AppIcon app={app} />
            <span className="min-w-0 flex-1">
              <span className="block text-data break-words text-primary">{step.nodeName}</span>
              <span className="block font-mono text-meta break-words text-muted">
                {step.flowName} · {step.where}
              </span>
            </span>
            <Link
              to="/flows/$flowId"
              params={{ flowId: step.flowId }}
              search={{ node: step.nodeKey }}
              className="shrink-0 text-meta text-primary underline"
            >
              Open on canvas
            </Link>
          </li>
        ))}
      </ul>
    )}
  </Modal>
);
